import axios from 'axios'

export default {
  login (credentials) {
    return axios.post(process.env.VUE_APP_BACKEND_BASE_URL + '/login', {
      email: credentials.email,
      password: credentials.password
    }).then((response) => {
      return response
    })
  },
  validateCustomer () {
    return axios.get(process.env.VUE_APP_BACKEND_BASE_URL + '/customer').then((response) => {
      return response
    })
  }
}
